import { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import LoadingSpinner from './LoadingSpinner';

const LoadingContext = createContext();

export function LoadingProvider({ children }) {
    const [isLoading, setIsLoading] = useState(false);
    const location = useLocation();

    useEffect(() => {
        let timeoutId;

        const startLoading = () => {
            setIsLoading(true);
        };

        const stopLoading = () => {
            timeoutId = setTimeout(() => {
                setIsLoading(false);
            }, 300); // Small delay to ensure smooth transition
        };

        // When route changes, start loading
        startLoading();

        // When route change is complete, stop loading
        stopLoading();

        return () => {
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, [location.pathname]); // Trigger on route changes

    return (
        <LoadingContext.Provider value={{ isLoading, setIsLoading }}>
            {isLoading && <LoadingSpinner />}
            {children}
        </LoadingContext.Provider>
    );
}

export const useLoading = () => useContext(LoadingContext);